import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function PageHeaderView
 * @return {React.Component}
 * @exported true
 * @description this is the page header that goes at the top of most pages.
 * @example
 * <PageHeaderView />
 */

export default function PageHeaderView(props) {
  const text = props.text ?? "[PageName]";
  const className = props.className ?? "";  

  return (
    <div className={className + " page-header-view flex-container flex-horizontal align-center"}>
        <SVGAsset id="LeftChevronIcon" className="back-chevron clickable set-width" onClick={props.onClick} />
        <p className="text-center page-heading flex-width">{text}</p>
        <div className="set-width place-holder"></div>
    </div>
  );
}